"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
const styleOverrides = {
  root: ({
    theme
  }) => ({
    marginTop: 17,
    [`&.${_material.stepConnectorClasses.active}, &.${_material.stepConnectorClasses.completed}`]: {
      [`& .${_material.stepConnectorClasses.line}`]: {
        backgroundColor: theme.palette.primary.main
      }
    }
  }),
  alternativeLabel: {
    left: 'calc(-50% + 35px)',
    right: 'calc(50% + 35px)',
    border: 0,
    top: 0
  },
  lineHorizontal: ({
    theme
  }) => ({
    borderTopStyle: 'none',
    height: 5,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.grey['200']
  })
};
var _default = exports.default = {
  styleOverrides
};
//# sourceMappingURL=MuiStepConnector.js.map